import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TReducerState } from '../../app.config';
import { environment } from '../../core/environments/environment';
import { MonitoringService } from '../../core/error-handler/monitoring.service';
import { ThemeSwitcherComponent } from '../../shared/components/theme-switcher/theme-switcher.component';
import { IClientInfo, IClientInfoState } from '../../state/client-info/client-info.interface';
import { UserEffects } from '../../state/user/user.effects';
import { ScwAppSwitcherComponent } from './scw-app-switcher/scw-app-switcher.component';

@Component({
  animations: [
    trigger('slideDownDisappear', [
      state(
        'void',
        style({
          transform: 'translateY(-100%)',
        }),
      ),
      transition('* => void', [animate('500ms ease-in-out', style({ transform: 'translateY(150%)' }))]),
    ]),
    trigger('slideDownAppear', [
      state(
        'void',
        style({
          transform: 'translateY(-100%)',
        }),
      ),
      transition('void => *', [animate('500ms ease-in-out', style({ transform: 'translateY(50%)' }))]),
    ]),
  ],
  imports: [
    MatToolbar,
    NgIf,
    MatMenuTrigger,
    MatIcon,
    TranslateModule,
    MatMenu,
    RouterLink,
    MatIconButton,
    MatButton,
    MatMenuItem,
    ThemeSwitcherComponent,
    MatDivider,
    ScwAppSwitcherComponent,
    MatMenuContent,
    MatTooltip,
  ],
  selector: 'app-toolbar',
  styleUrl: './toolbar.component.scss',
  templateUrl: './toolbar.component.html',
})
export class ToolbarComponent implements OnInit, OnDestroy {
  public clientInfo: IClientInfo | null = null;
  public readonly version: string = environment.version;

  private readonly subscriptions: Subscription[] = [];
  public fullName: string = UserEffects.getUser().name;
  public isToolAdmin: boolean = UserEffects.getUser().isAdmin;
  public readonly workspaceModules = this.store.selectSignal(({ user }) => user.user?.authorizations.workspaceModules);

  constructor(
    private readonly store: Store<TReducerState>,
    private readonly monitoringService: MonitoringService,
  ) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.store
        .select(({ clientInfo }) => clientInfo)
        .subscribe((clientInfoState: IClientInfoState) => {
          this.clientInfo = clientInfoState.clientInfo;
        }),
    );
  }

  public refresh(): void {
    window.location.reload();
  }

  public logout(): void {
    this.monitoringService.logoutAuthorizedUser();
    localStorage.clear();
    window.location.assign(`${environment.ssoUrl}${environment.ssoLogoutUrl}`);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription?.unsubscribe());
  }
}
